import { color } from "./constants";

const primaryBackground = {
    backgroundColor: color.primary
}

const primaryBorder = {
    borderColor: color.primary
}

const primaryColor = {
    color: color.primary
}

const secondaryBackground = {
    backgroundColor: color.secondary
}

const secondaryBorder = {
    borderColor: color.secondary
}

const secondaryColor = {
    color: color.secondary
}

export const baseCss = { primaryBackground, primaryBorder, secondaryBackground, secondaryBorder, primaryColor, secondaryColor }


// WEBPACK FOOTER //
// ./src/components/common/css.js